import React, { useEffect, useMemo, useState } from "react";
import Loading from "../general/Loading";
import OrderInvoice from "./OrderInvoice";
import SaleOrderInvoice from "./SaleOrderInvoice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const Reports = ({userData}) => {
                const [loading, setLoading] = useState(false);
                const [searchQuery, setSearchQuery] = useState('');
const [productSearch, setProductSearch] = useState("");
  const [reportType, setReportType] = useState("sales");
  const [orderType, setOrderType] = useState("all");
  const [reports, setReports] = useState([]);
const [selectedFromDate, setSelectedFromDate] = useState(() => {
  const date = new Date();
  date.setDate(date.getDate() - 7);

  return date.toISOString().split("T")[0];
});

const [selectedProduct, setSelectedProduct] = useState(null);
const [showProductDetail, setShowProductDetail] = useState(false);
const [showDetail, setShowDetail] = useState(false);
            const [selectedOrder, setSelectedOrder] = useState('');

const [selectedToDate, setSelectedToDate] = useState(() => {
  const today = new Date().toISOString().split("T")[0];
  return today;
});


const fetchReport = async (selectedFromDate, selectedToDate) => {
  setLoading(true);

  try {
    const response = await fetch(`https://api.hargharmart.com/get-sale-reports?fromDate=${selectedFromDate}&toDate=${selectedToDate}`);
    
    if (response.ok) {
      const data = await response.json();
      console.log(data);
      setReports(data);
    }
  } catch (err) {
    console.error("Error loading:", err);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
fetchReport(selectedFromDate, selectedToDate);
}, [])


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


      const handleShowDetail = (order) => {
    setSelectedOrder(order);
    setShowDetail(true);
  }

const filteredReports = reports
  .filter((order) => {
    if (orderType == "all") return true;
    return order.order_type == orderType;
  })
  .filter((order) => {
    if (!searchQuery) return true;
    return String(order.id)
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });


  const exportToExcel = () => {


    const exportData = filteredReports.map((order) => ([
    order.id,
    formatDateTime(order.order_date),
    order.order_type,
    order.name,
    order.mobile,
    // Math.round(
    //   Number(order.total_amount)
    // ),
    // Math.round(
    //   Number(order.charges)
    // ),
    // Math.round(Number(order.total_amount) + Number(order.charges)),

    Number(order.total_amount || 0).toFixed(2),

Number(order.charges || 0).toFixed(2),

Number(order.total_amount || 0).toFixed(2),
    JSON.parse(order.order_items || "[]").length,
  ]));


   const header = [
    "Order ID",
    "Date",
    "Type",
    "Customer",
    "Mobile",
    "Sub Total",
    "Charges",
    "Grand Total",
    "Items Count",
  ];

  const meta = [
      ["", "Sales Report"],
[      "Generated On", new Date().toLocaleString()],
[      ],
 [     "From Date", selectedFromDate, '', "To Date", selectedToDate],
    [],
  ];

   const sheetData = [
    ...meta,
    header,
    ...exportData,
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

 const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

  XLSX.writeFile(
    workbook,
    `Sales_Report_${selectedFromDate}_to_${selectedToDate}.xlsx`
  );
};



const getTierPrice = (tiers, qty) => {
  let price = Number(tiers?.[0]?.price || 0);

  tiers.forEach(t => {
    if (qty >= Number(t.qty)) {
      price = Number(t.price);
    }
  });

  return price;
};



// const getProductWiseData = () => {
//   const productMap = {};

//   filteredReports.forEach((order) => {
//     const items = JSON.parse(order.order_items || "[]");

//     items.forEach((item) => {
//       const key = item.itemId || item.id;
//   const tiers = JSON.parse(item.sell_price || "[]");
//   const qty = item.avail_qty || item.item_qty || 1;
//   const price = getTierPrice(tiers, qty);

//       if (!productMap[key]) {
//         productMap[key] = {
//           itemId: key,
//           name: item.name,
//           totalQty: 0,
//           totalAmount: 0,
//           orders: [],
//         };
//       }

//       productMap[key].totalQty += order.order_type == 'Online' ? qty : Number(item.quantity || 0);
//       productMap[key].totalAmount += order.order_type == 'Online' ? Number(price || 0) : Number(item.amount || 0);

//       productMap[key].orders.push({
//         orderId: order.id,
//         customer: order.name,
//         mobile: order.mobile,
//         date: order.order_date,
//         qty: item.quantity || item.avail_qty || item.item_qty || 0,
//       });
//     });
//   });

//   return Object.values(productMap);
// };

const getProductWiseData = () => {
  const productMap = {};

  filteredReports.forEach((order) => {
    let items = [];

    try {
      items = JSON.parse(order.order_items || "[]");
    } catch (e) {
      console.error("Invalid order_items:", e);
      return;
    }

    items.forEach((item) => {
      const key = item.itemId || item.id;

      if (!key) return;

      // ============================================================
      // QUANTITY
      // ============================================================

      const qty = Number(
        item.avail_qty ??
        item.item_qty ??
        item.quantity ??
        0
      );

      // ============================================================
      // SELL PRICE
      // ============================================================

      let tiers = [];

      try {
        tiers = JSON.parse(item.sell_price || "[]");
      } catch (e) {
        tiers = [];
      }

      const price = getTierPrice(tiers, qty);

      // ============================================================
      // ACTUAL ITEM AMOUNT
      // ============================================================

      let itemTotal = 0;

      if (order.order_type === "Online") {
        // Online order:
        // price × quantity

        itemTotal = price * qty;
      } else {
        // Sale order:
        // If backend already provides amount, use it.
        // Otherwise calculate price × quantity.

        const backendAmount = Number(item.amount);

        if (Number.isFinite(backendAmount) && backendAmount > 0) {
          itemTotal = backendAmount;
        } else {
          itemTotal = price * qty;
        }
      }

      // ============================================================
      // CREATE PRODUCT
      // ============================================================

      if (!productMap[key]) {
        productMap[key] = {
          itemId: key,
          name: item.name,
          totalQty: 0,
          totalAmount: 0,
          orders: [],
        };
      }

      // ============================================================
      // ADD QUANTITY
      // ============================================================

      productMap[key].totalQty += qty;

      // ============================================================
      // ADD ACTUAL SALES AMOUNT
      // ============================================================

      productMap[key].totalAmount += itemTotal;

      // ============================================================
      // CUSTOMER HISTORY
      // ============================================================

      productMap[key].orders.push({
        orderId: order.id,
        customer: order.name,
        mobile: order.mobile,
        date: order.order_date,
        qty: qty,
      });
    });
  });

  return Object.values(productMap);
};


const productData = useMemo(() => getProductWiseData(), [reports, orderType]);


const filteredProductData = productData.filter((product) => {
  if (!productSearch) return true;

  return product.name
    ?.toLowerCase()
    .includes(productSearch.toLowerCase());
});

  return (
    <>
    <section className="my-4">
      <div className="px-4">
        <p className="page-title">Reports</p>

<div className='bg-white p-1 my-3 rounded-2 d-md-flex justify-content-between'>

<div className="d-flex py-2">
          <button
            onClick={() => setReportType("sales")}
            className={`me-3 ${
              reportType === "sales"
                ? "edit-btn"
                : "close-btn"
            }`}
          >
            Sales Report
          </button>

          <button
            onClick={() => setReportType("product")}
            className={`${
              reportType === "product"
                ? "edit-btn"
                : "close-btn"
            }`}
          >
            Product Wise Report
          </button>
</div>


<div className="d-md-flex py-2">
                      <input
    type="date"
    className="form-control my-1"
    value={selectedFromDate}
    onChange={(e) => setSelectedFromDate(e.target.value)}
  />

                      <input
    type="date"
    className="form-control mx-md-2 my-1"
    value={selectedToDate}
    onChange={(e) => setSelectedToDate(e.target.value)}
  />


  {/* FILTER BUTTON */}
  <button
    className="btn btn-dark my-1"
    onClick={() => fetchReport(selectedFromDate, selectedToDate)}
  >
    Filter
  </button>
</div>


</div>

<div className='bg-white p-3 my-3 rounded-2'>
          {reportType === "sales" ? (
            <>

            <div className="d-md-flex justify-content-between mb-3">

              
                                <div className='d-flex bg-light rounded-2  py-2 '>
                        <i class="fa-solid fa-magnifying-glass text-darkblue  px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-light w-100 py-0"
                            placeholder="Search By Order Id"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />                        
                    </div>
             <p className="text-gray-500 text-sm">
                Showing <strong>{orderType}</strong> orders sales report.
              </p>
             </div> 
<div className="d-flex justify-content-end mt-0">
  <button
    className="edit-btn px-3 py-2"
    onClick={exportToExcel}
  >
    Export Excel
  </button>
</div>
              <div className="table-responsive">
<table className="w-100">
<thead className="inventory-row">
    <th>Order Id</th>
    <th>Date</th>
    <th>Type</th>
    <th>Customer</th>
    <th>Amount</th>
    <th>Items</th>
    <th>Activity</th>
</thead>


                                  {filteredReports.map(order => {
                                  return (

<tr className='inventory-row'>
<td className='py-2'>#{order.id}</td>
<td className='py-2'>{formatDateTime(order.order_date)}</td>
<td className='py-2'>{order.order_type}</td>
<td className='py-2'>{order.name}</td>
{/* <td className='py-2'>₹ {Math.round(Number(order.total_amount) + Number(order.charges))}</td> */}

<td className='py-2'>
  ₹ {Number(order.total_amount || 0).toFixed(2)}
</td>
<td className='py-2'>{JSON.parse(order.order_items).length}</td>
<td className='py-2 text-danger'>
 <span className='ms-2 edit-btn p-2' onClick={() => handleShowDetail(order)}>View</span> 
</td>
</tr>
   )   }   )}



</table>

              </div>

              {/* Sales report table/chart here */}
            </>
          ) : (
            <>
                  <div className="d-md-flex justify-content-between mb-3">

              
                                <div className='d-flex bg-light rounded-2  py-2 '>
                        <i class="fa-solid fa-magnifying-glass text-darkblue  px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-light w-100 py-0"
                            placeholder="Search By Product Name"
                            value={productSearch}
                            onChange={(e) => setProductSearch(e.target.value)}
                        />                        
                    </div>
 <p className="text-gray-500 text-sm">
                Showing <strong>{orderType}</strong> orders Product summary.
              </p>
              </div>

    <div className="table-responsive">
      <table className="w-100">
        <thead className="inventory-row">
          <th>Product</th>
          <th>Price</th>
          <th>Qty Sold</th>
          <th>Total Amount</th>
          <th>Action</th>
        </thead>

        {/* {filteredProductData.map((product) => (
          <tr className="inventory-row" key={product.itemId}>
            <td className="py-2">{product.name}</td>
            <td className="py-2">₹ {Math.round(product.totalAmount)}</td>
            <td className="py-2">{product.totalQty}</td>
            <td className="py-2">₹ {product.totalQty * Math.round(product.totalAmount)}</td>
            <td className="py-2">
              <span
                className="edit-btn p-2"
                onClick={() => {
                  setSelectedProduct(product);
                  setShowProductDetail(true);
                }}
              >
                View
              </span>
            </td>
          </tr>
        ))} */}

        {filteredProductData.map((product) => {
  const averagePrice =
    product.totalQty > 0
      ? product.totalAmount / product.totalQty
      : 0;

  return (
    <tr className="inventory-row" key={product.itemId}>
      <td className="py-2">
        {product.name}
      </td>

      <td className="py-2">
        ₹ {averagePrice.toFixed(2)}
      </td>

      <td className="py-2">
        {product.totalQty}
      </td>

      <td className="py-2">
        ₹ {product.totalAmount.toFixed(2)}
      </td>

      <td className="py-2">
        <span
          className="edit-btn p-2"
          onClick={() => {
            setSelectedProduct(product);
            setShowProductDetail(true);
          }}
        >
          View
        </span>
      </td>
    </tr>
  );
})}
      </table>
    </div>
              {/* Product wise report table here */}
            </>
          )}
        </div>


{showProductDetail && selectedProduct && (
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-md-8 animate__animated animate__zoomIn rounded mx-auto px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

       <p className='fw-semibold fs-5'>{selectedProduct.name}</p>
      <p className="text-muted">Customer Purchase History</p>

      <div className="table-responsive">
        <table className="w-100">
          <thead className="inventory-row">
            <th>Order ID</th>
            <th>Date</th>
            <th>Customer</th>
            <th>Mobile</th>
            <th>Qty</th>
          </thead>

          {selectedProduct.orders.map((o, i) => (
            <tr className="inventory-row" key={i}>
              <td>#{o.orderId}</td>
              <td>{formatDateTime(o.date)}</td>
              <td>{o.customer}</td>
              <td>{o.mobile}</td>
              <td>{o.qty}</td>
            </tr>
          ))}
        </table>
      </div>

      <button
        className="close-btn mt-3"
        onClick={() => setShowProductDetail(false)}
      >
        Close
      </button>
    </div>
  </section>
)}

      </div>
    </section>

    
{showDetail && (
selectedOrder.order_type == 'Online' ?
<OrderInvoice
setShowDetail={setShowDetail} selectedOrder={selectedOrder} userData={userData} />

: <SaleOrderInvoice
setShowDetail={setShowDetail} selectedOrder={selectedOrder} userData={userData} />
)
}

{loading && <Loading setLoading={setLoading} />}

</>
  );
};

export default Reports;